import { render } from "./NuvemList.vue?vue&type=template&id=62a5586e"
import script from "./NuvemList.vue?vue&type=script&lang=js"
export * from "./NuvemList.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__